$(document).ready(function () {

    // Tabs control homepage
    $('ul.tabs:not(.no-action) li').click(function () {
        var tab_id = $(this).attr('data-tab');

        $('ul.tabs li').removeClass('current');
        $('.tab-content').removeClass('current');

        $(this).addClass('current');
        $("#" + tab_id).addClass('current');
    })
    // Tabs control cart
    $('.btn-step > span').click(function () {
        var tab_id = $(this).attr('data-tab');

        $('ul.tabs li').removeClass('current');
        $('.tab-content').removeClass('current');

        $("#" + tab_id).addClass('current');
        $('ul.tabs li[data-tab=' + tab_id + ']').addClass('current');
    })
    // Product detail slider
    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
    });
    $('.slider-nav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        focusOnSelect: true,
        arrows: false,
    });
    $('.carousel-inner, section.content .slider-ads').slick({
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        autoplay: true,
        dots: true,
        arrows: false,
    });
    // remove empty link in homepage
    $('.sport-category li a:empty').parent().remove();
    
    // initialization of go to
    $.FMCore.components.FMGoTo.init('.js-go-to');
})


$(document).on("change", "#tabColorSize", function () {
    var tabId = $(this).val();
    $(".jtabs").removeClass("active");
    $('a[href="#' + tabId + '"]').tab('show');
})

//header mobile
// When the user scrolls the page, execute headerScroll
window.onscroll = function () { headerScroll() };

// Get the header
var header = $("header");
var mainMenu = $("#main-menu");

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function headerScroll() {
    if (window.pageYOffset > 150) {
        header.addClass("header-scroll");
    } else if (!mainMenu.hasClass("active")){
        header.removeClass("header-scroll");
    }
}